import { createPortal } from "react-dom";
import { useEffect, useState } from "react";
import styled from "styled-components";

import TextButton from "@common/ui/TextButton";

import { useStore } from "@state/store";
import gsap from "gsap";

gsap.config({
  nullTargetWarn: false,
});

function Specs() {
  const [specIndex, setSpecIndex] = useState(0);
  const [showControls, setShowControls] = useState(false);
  const contentControls = useStore((s) => s.contentControls);
  const finishes = ["Attica", "Concrete", "Moonlight Fog", "Uplift"];
  const files = ["attica", "concrete", "moonlight", "uplift"];

  useEffect(() => {
    if (contentControls?.index === 1) {
      setShowControls(true);
    } else {
      gsap.to("#spec-controls", {
        autoAlpha: 0,
        duration: 0.4,
        ease: "power3.inOut",
        onComplete: () => {
          setShowControls(false);
        },
      });
    }
  }, [contentControls]);

  useEffect(() => {
    if (showControls) {
      gsap.to("#spec-controls", {
        autoAlpha: 1,
        duration: 0.4,
        ease: "power3.inOut",
        onComplete: () => {
          if (contentControls?.index !== 1) {
            setShowControls(false);
          }
        },
      });
    }
  }, [showControls]);
  return (
    <>
      <SpecsWrapper>
        {files.map((file, i) => {
          return (
            <>
              <Image
                key={`file-${file}-${i}`}
                src={`assets/imgs/specs/${file}.webp`}
                style={{
                  opacity: specIndex === i ? 1 : 0,
                }}
              />
              <Title
                style={{
                  opacity: specIndex === i ? 1 : 0,
                }}
              >
                {finishes[i]}
              </Title>
            </>
          );
        })}
      </SpecsWrapper>
      {showControls &&
        createPortal(
          <SpecControls id="spec-controls">
            {finishes.map((finish, i) => {
              return (
                <TextButton
                  key={`finish-${finish}-${i}`}
                  onClick={() => setSpecIndex(i)}
                  style={{
                    opacity: specIndex === i ? 0.7 : 1,
                    background: finish === "Uplift"
                      ? "var(--accent)"
                      : "var(--secondary)",
                    color: finish === "Uplift" ? "var(--black)" : "white",
                  }}
                >
                  {finish}
                </TextButton>
              );
            })}
          </SpecControls>,
          document.body,
        )}
    </>
  );
}

export default Specs;

const SpecsWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const Image = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.4s ease-in-out;
`;
const Title = styled.div`
  position: absolute;
  top: 0%;
  right: 0%;
  width: 100%;
  transition: opacity 0.4s ease-in-out;
  text-align: right;
  padding: 0.5rem 4rem;
  font-size: 3rem;
  font-family: SecondaryFont;
  color: white;
  background-color: rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(5px);
  mask-size: 100%;
  mask-repeat: no-repeat;
  mask: linear-gradient(to left, rgba(0, 0, 0, 1) 10%, rgba(0, 0, 0, 0) 40%);
`;

const SpecControls = styled.div`
  position: fixed;
  left: 0;
  bottom: 10rem;
  left: 4rem;
  width: calc(15% - 6rem);
  color: white;
  cursor: pointer;
  pointer-events: all;
  z-index: 20000;
  display: flex;
  flex-wrap: wrap;
  height: 12rem;
  gap: 1rem;
  opacity: 0;
  visibility: hidden;

  & div {
    width: 100% !important;
    background-color: var(--secondary);
    border-radius: 5px;
    transition: unset;
    transition: opacity 0.4s ease-in-out;
    border: 1px solid white;
  }
`;
